import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class RouteTrackerService {
  private returnUrl: string | null = null;
  private readonly STORAGE_KEY = 'returnUrl';

  constructor(private router: Router) {
    this.returnUrl = sessionStorage.getItem(this.STORAGE_KEY);
  }

  public setReturnUrl(url: string): void {
    if (url === '/login' || url === '/' || url === '') {
      return;
    }
    
    this.returnUrl = url;
    sessionStorage.setItem(this.STORAGE_KEY, url);
  }

  public getReturnUrl(): string | null {
    return this.returnUrl || sessionStorage.getItem(this.STORAGE_KEY);
  }

  public navigateToReturnUrl(): void {
    const url = this.getReturnUrl() || '/';
    this.clearReturnUrl();
    this.router.navigateByUrl(url);
  }

  public clearReturnUrl(): void {
    this.returnUrl = null;
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}